import { useTranslation } from 'react-i18next';
const prefix = 'studentManagement.tabs.tutors';
export function useTexts() {
  const { t } = useTranslation();
  return {
    tabTitle: t(`${prefix}.tabTitle`),
    sectionTitle: t(`${prefix}.sectionTitle`),
    notAssigned: t(`${prefix}.notAssigned`),
    noResults: t(`${prefix}.noResults`),
    table: {
      studyPlan: t(`${prefix}.table.studyPlan`),
      nameAndId: t(`${prefix}.table.nameAndId`),
      email: t(`${prefix}.table.email`),
      action: t(`${prefix}.table.action`),
      editTutorButton: t(`${prefix}.table.editTutorButton`),
    },
    modal: {
      studyPlan: t(`${prefix}.modal.studyPlan`),
      nameAndId: t(`${prefix}.modal.nameAndId`),
      email: t(`${prefix}.modal.email`),
      buttons: {
        cancel: t(`${prefix}.modal.buttons.cancel`),
        save: t(`${prefix}.modal.buttons.save`),
      },
    },
    toast: {
      success: t(`${prefix}.toast.success`),
      error: t(`${prefix}.toast.error`),
    },
  };
}
